import { render, staticRenderFns } from "./SharedOwnershipRent.vue?vue&type=template&id=7df8aa84"
import script from "./SharedOwnershipRent.vue?vue&type=script&lang=js"
export * from "./SharedOwnershipRent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports